<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 09:54:34
 * @LastEditTime: 2020-06-16 14:32:17
 * @Description: 原 PSS 风格面包屑导航栏组件
 -->
<template>
  <ul class="breadcrumb">
    <li v-for="item in list" :key="item.text">
      <img src="../../../../assets/image/arrow-right@pss.jpg">
      <a v-if="item.href" :href="item.href">{{ item.text }}</a>
      <span v-else>{{ item.text }}</span>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PssBreadcrumb',
  computed: {
    ...mapGetters({
      list: 'pageStore/breadcrumb',
    }),
  },
};
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: 33px;
  background: url('../../../../assets/image/bg-breadcrumb@pss.jpg') no-repeat;
  line-height: 33px;
  font-size: 12px;
  font-weight: bold;

  > li {
    > img {
      margin: 0 10px;
      vertical-align: middle;
    }
  }

  a {
    color: #4c4c4c;
  }
}
</style>
